import React, { useEffect, useRef, useState } from "react";
import { Navigate, Outlet, redirect, useSearchParams } from "react-router-dom";
import { Backdrop, Chip, CircularProgress, Typography } from "@mui/material";
import { enqueueSnackbar, SnackbarProvider } from "notistack";
import {
  BACKEND_URL,
  NIMBLE_AUTH_API,
  NIMBLE_PAYABLE_API,
} from "../../helpers/variables";

const InboxLoader = () => {
  const [searchParams] = useSearchParams();
  const client_url = searchParams.get("client_url");
  const corporation_id = searchParams.get("corporation_id");
  const nimbleAuthID = searchParams.get("nimbleAuthID");

  const [loading, setLoading] = useState(true);
  const [context, setContext] = useState(null);

  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    loader();
  }, []);

  async function getClient() {
    let res = await fetch(`${BACKEND_URL}/get_client?client_url=${client_url}`)
    return res.json()
  }

  async function exchangeOAuth(userManagementVersion) {
    let res = await fetch(`${NIMBLE_AUTH_API}/${userManagementVersion}/OpenApiauth/ExchangeOAuth`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token: nimbleAuthID }),
    });
    let data = await res.json();
    if (data["statusCode"] !== 200) throw new Error(data["status"]);
    return data;
  }

  async function getRestrictedVendors(token) {
    let res = await fetch(
      `${NIMBLE_PAYABLE_API}/GetRestrictedVendorsIO?CorpID=${corporation_id}`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    let data = await res.json();
    if (data["statusCode"] != 200) {
      console.error(data["status"]);
      return []
    }
    return data["vendorId"];
  }

  async function loader() {
    if (!client_url || !corporation_id || !nimbleAuthID) {
      throw new Response("Missing required parameters", { status: 400 });
    }
    try {
      let { user_management_version } = await getClient()
      let { token } = await exchangeOAuth(user_management_version);
      let restrictedVendorIds = await getRestrictedVendors(token);
      setContext({ token, restrictedVendorIds });
    } catch (e) {
      console.error(e);
      enqueueSnackbar(`${e}`, { variant: "error" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <SnackbarProvider
      autoHideDuration={3000}
      anchorOrigin={{ horizontal: "center", vertical: "top" }}
    >
      {loading ? (
        <Backdrop open>
          <CircularProgress />
        </Backdrop>
      ) : context ? (
        <Outlet context={context} />
      ) : (
        <Navigate to={"/"} />
      )}
    </SnackbarProvider>
  );
};

export default InboxLoader;
